module.exports = __webpack_public_path__ + "static/media/recommend.2dd60ff0.png";